import React, { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import { useSession } from '@/hooks/useSession';
import { LevelProgressCard } from '@/components/custom/level-progress-card';

// Card de nível/progresso da trilha (Versão B). Reusa o mesmo LevelProgressCard
// da tela de Conquistas, alimentado pelos dados reais de /user_milestones, para
// que os dois cards fiquem idênticos.
export function HeroLevelCard() {
  const client = useClient();
  const { session } = useSession();
  const userId = session?.user?.id;
  const [milestones, setMilestones] = useState();

  useEffect(() => {
    if (!userId) return undefined;
    let mounted = true;
    client.fetch(`/user_milestones?user_id=${userId}`).then(res => {
      if (mounted) setMilestones(res?.data);
    });
    return () => {
      mounted = false;
    };
  }, [client, userId]);

  return (
    <LevelProgressCard
      milestones={milestones}
      className="h-full"
    />
  );
}
